import TriggerBase from './trigger-base';
import Utils from '../utils';

/**
 * handles onLoad lazy-load elements
 */
export default class OnScroll extends TriggerBase {
	observer;
	constructor( element ) {
		super( element );
		this.event = [ 'scroll', 'resize' ];
		this.eventHandler = Utils.debounce( this.eventHandler, 50 );
		if ( 0 !== this.getWindowScrollOffset() && this.isElementInOrNearViewport() ) {
			this.trigger().then();
			return;
		}
		this.addListener();
	}

	addListener() {
		if ( 'IntersectionObserver' in window ) {
			const options = {
				root: null,
				rootMargin: '-' + this.getScrollOffset() + 'px 0px 0px 0px',
				threshold: [ 0 ]
			};
			this.observer = new IntersectionObserver( ( [ entry ] ) => this.intersectCallback( entry ), options );
			this.observer.observe( this.element );
			return;
		}
		super.addListener();
	}

	intersectCallback( entry ) {
		if ( entry.isIntersecting ) {
			this.trigger().then();
			// unobserve
			this.observer.unobserve( this.element );
			// destroy observer
			this.observer.disconnect();
		}
	}

	/**
	 * @returns {boolean}
	 */
	shouldTrigger() {
		return super.shouldTrigger() && this.isElementInOrNearViewport();
	}

	/**
	 * check if the element is in the viewport or close enough to trigger the lazy load
	 * @returns {boolean}
	 */
	isElementInOrNearViewport() {
		if ( this.observer ) {
			return true;
		}
		const elementHeight = this.getElementScrollOffset(),
			currentHeight = this.getWindowScrollOffset() + this.getScrollOffset() + 50;
		return currentHeight >= elementHeight;
	}

	/**
	 * get the offset above element to trigger lazy load
	 * @returns {number}
	 */
	getScrollOffset() {
		return this.data.scrollOffset || 0;
	}

	/**
	 * get element scroll offset from top of page
	 * @returns {number}
	 */
	getElementScrollOffset() {
		return this.element.getBoundingClientRect().top || 0;
	}

	/**
	 * get window scroll offset from top
	 * @returns {number}
	 */
	getWindowScrollOffset() {
		return this.element.ownerDocument.defaultView.pageYOffset || 0;
	}
}
